module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/d1042ec0721c96f365236de2b75e49a8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/silver-certificate.png
// module id = pJ47
// module chunks = 1